"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _isArray = _interopRequireDefault(require("transmute/isArray"));

var _isEmpty = _interopRequireDefault(require("transmute/isEmpty"));

var _isString = _interopRequireDefault(require("transmute/isString"));

var _I18n = _interopRequireDefault(require("I18n"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _immutable = require("immutable");

var _generalStore = require("general-store");

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var _ActionFormInstancesStore = _interopRequireDefault(require("crm_ui/flux/integrations/ActionFormInstancesStore"));

var _ActionFormActions = _interopRequireDefault(require("crm_ui/flux/integrations/ActionFormActions"));

var _IntegrationsActionFormField = _interopRequireDefault(require("crm_ui/profile/sidebar/contacts/IntegrationsActionFormField"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _CRMDateInput = _interopRequireDefault(require("crm_ui/date/CRMDateInput"));

var _UIExpandingTextArea = _interopRequireDefault(require("UIComponents/input/UIExpandingTextArea"));

var _UISelect = _interopRequireDefault(require("UIComponents/input/UISelect"));

var _UITextInput = _interopRequireDefault(require("UIComponents/input/UITextInput"));

var _UITimePicker = _interopRequireDefault(require("UIComponents/input/UITimePicker"));

var _MomentTypes = require("UIComponents/constants/MomentTypes");

var _ComponentWithPartials = _interopRequireDefault(require("UIComponents/mixins/ComponentWithPartials"));

var _HubAPI = _interopRequireDefault(require("crm_data/api/HubAPI"));

var _reactImmutableProptypes = _interopRequireDefault(require("react-immutable-proptypes"));

var API_DOMAIN = _HubAPI.default.API_DOMAIN;
var FieldType = {
  Date: 'Date',
  DateTime: 'DateTime',
  EnumerationMulti: 'EnumerationMultiSelect',
  EnumerationSingle: 'EnumerationSingleSelect',
  EnumerationSingleDynamic: 'EnumerationSingleSelectDynamic',
  LongText: 'LongText',
  Text: 'Text',
  Time: 'Time',
  WebhookMulti: 'WebhookMultiSelect',
  WebhookSingle: 'WebhookSingleSelect',
  WebhookSingleDynamic: 'WebhookSingleSelectDynamic'
};
var TRIGGERS_DYNAMIC = [FieldType.EnumerationSingleDynamic, FieldType.WebhookSingleDynamic];
var MULTISELECT = [FieldType.EnumerationMulti, FieldType.WebhookMulti];
var SINGLE_SELECT = [FieldType.EnumerationSingle, FieldType.WebhookSingle, FieldType.EnumerationSingleDynamic, FieldType.WebhookSingleDynamic];
var dependencies = {
  actionFormInstance: {
    stores: [_ActionFormInstancesStore.default],
    deref: function deref(_ref) {
      var actionForm = _ref.actionForm,
          contactId = _ref.contactId;
      return _ActionFormInstancesStore.default.get(actionForm.get('appId'), actionForm.get('formId'), contactId);
    }
  },
  dynamicForm: {
    stores: [_ActionFormInstancesStore.default],
    deref: function deref(_ref2) {
      var actionForm = _ref2.actionForm,
          contactId = _ref2.contactId;

      var actionFormInstance = _ActionFormInstancesStore.default.get(actionForm.get('appId'), actionForm.get('formId'), contactId);

      if (!actionFormInstance) return undefined;
      return actionFormInstance.get('dynamicForm');
    }
  },
  submissionResponse: {
    stores: [_ActionFormInstancesStore.default],
    deref: function deref(_ref3) {
      var actionForm = _ref3.actionForm,
          contactId = _ref3.contactId;

      var actionFormInstance = _ActionFormInstancesStore.default.get(actionForm.get('appId'), actionForm.get('formId'), contactId);

      if (!actionFormInstance) return undefined;
      return actionFormInstance.get('submissionResponse');
    }
  }
};
var IntegrationsActionForm = (0, _createReactClass.default)({
  displayName: 'IntegrationsActionForm',
  mixins: [_ComponentWithPartials.default],
  propTypes: {
    actionForm: _propTypes.default.object.isRequired,
    actionFormInstance: _reactImmutableProptypes.default.map,
    contactId: _propTypes.default.number.isRequired,
    dynamicForm: _reactImmutableProptypes.default.map,
    submissionResponse: _reactImmutableProptypes.default.map
  },
  getInitialState: function getInitialState() {
    return {
      invalidFields: [],
      showValidationError: false,
      values: {}
    };
  },
  componentDidMount: function componentDidMount() {
    var actionForm = this.props.actionForm;
    return _ActionFormActions.default.fetchInstance(actionForm.get('appId'), actionForm.get('formId'), this.props.contactId);
  },
  getFields: function getFields(includeDynamic) {
    if (includeDynamic == null) {
      includeDynamic = true;
    }

    var fields = this.props.actionFormInstance != null ? this.props.actionFormInstance.get('fields') : undefined;

    if (includeDynamic && this.props.dynamicForm) {
      fields = fields != null ? fields.concat(this.props.dynamicForm.get('fields')) : undefined;
    }

    return fields || new _immutable.List();
  },
  getFieldValue: function getFieldValue(field) {
    var value = this.state.values[field.get('name')] || field.get('defaultValue');

    if (MULTISELECT.indexOf(field.get('type')) !== -1) {
      if ((0, _isString.default)(value) && value.indexOf(',') >= 0) {
        value = value.split(',').map(function (word) {
          return word.trim();
        }).filter(function (word) {
          return !(0, _isEmpty.default)(word);
        });
      } else if (!(0, _isArray.default)(value)) {
        value = [value];
      }
    } else if (SINGLE_SELECT.indexOf(field.get('type')) !== -1) {
      value = value || '';
    }

    return value;
  },
  getInvalidFields: function getInvalidFields() {
    if (this.state.showValidationError) {
      return this.state.invalidFields;
    } else {
      return [];
    }
  },
  getRedirectUrl: function getRedirectUrl() {
    var _this$props = this.props,
        actionForm = _this$props.actionForm,
        contactId = _this$props.contactId;
    var appId = actionForm.get('appId');
    var formId = actionForm.get('formId');

    var portalId = _hubspot.default.get();

    var url = "https://" + API_DOMAIN + "/integrations/v1/" + appId + "/action-forms/" + formId + "/redirect";
    url += "?formId=" + formId + "&contactId=" + contactId + "&portalId=" + portalId;

    var _arr = Array.from(this.getValues());

    for (var _i = 0; _i < _arr.length; _i++) {
      var entry = _arr[_i];
      var fieldName = entry.fieldName,
          value = entry.value;
      url += "&" + encodeURIComponent(fieldName) + "=" + encodeURIComponent(value);
    }

    return url;
  },
  getValues: function getValues(includeDynamic) {
    var _this = this;

    if (includeDynamic == null) {
      includeDynamic = true;
    }

    var fields = this.getFields(includeDynamic);
    var values = [];
    fields.forEach(function (field) {
      var value = _this.getFieldValue(field);

      if (value) {
        values.push({
          fieldName: field.get('name'),
          label: field.get('label'),
          value: value
        });
      }
    });
    return values;
  },
  handleChange: function handleChange(field, event) {
    var values = this.state.values;

    if (MULTISELECT.indexOf(field.get('type')) !== -1) {
      var selectedValues = [];

      var _arr2 = Array.from(event.target.options);

      for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
        var o = _arr2[_i2];

        if (o.selected) {
          selectedValues.push(o.value);
        }
      }

      values[field.get('name')] = selectedValues;
    } else {
      values[field.get('name')] = event.target.value;
    }

    var valid = this.validate(false);

    if (TRIGGERS_DYNAMIC.indexOf(field.get('type')) !== -1) {
      this.setState({
        showValidationError: true
      });

      if (valid) {
        _ActionFormActions.default.dynamicFormChanged(this.props.actionFormInstance, this.getValues(false));
      }
    }

    return this.setState({
      values: values
    });
  },
  handleRedirect: function handleRedirect(e) {
    this.setState({
      showValidationError: true
    });

    if (!this.validate()) {
      e.preventDefault();
    }
  },
  handleSubmit: function handleSubmit(e) {
    e.preventDefault();
    this.setState({
      showValidationError: true
    });

    if (this.validate()) {
      _ActionFormActions.default.submitForm(this.props.actionFormInstance, this.props.dynamicForm, this.getValues());
    }
  },
  validate: function validate(includeDynamic) {
    if (includeDynamic == null) {
      includeDynamic = true;
    }

    var fields = this.getFields(includeDynamic);
    var values = this.getValues(includeDynamic);
    var invalidFields = [];
    fields.forEach(function (field) {
      if (field.get('required') && !values.find(function (f) {
        return f.fieldName === field.get('name');
      })) {
        invalidFields.push(field.get('name'));
      }
    });
    this.setState({
      invalidFields: invalidFields
    });
    return invalidFields.length === 0;
  },
  renderAction: function renderAction() {
    var isRedirect = this.props.actionFormInstance != null ? this.props.actionFormInstance.get('redirect') : undefined;
    return _react.default.createElement("section", {
      className: "m-top-6 text-center",
      key: "action"
    }, _react.default.createElement(_UIButton.default, {
      href: isRedirect ? this.getRedirectUrl() : undefined,
      onClick: isRedirect ? this.handleRedirect : this.handleSubmit,
      use: "tertiary-light",
      size: "small",
      target: isRedirect ? '_blank' : undefined
    }, this.props.actionForm.get('label')));
  },
  renderFieldInner: function renderFieldInner(field) {
    switch (field.get('type')) {
      case FieldType.LongText:
        return this.renderLongText(field);

      case FieldType.Text:
        return this.renderText(field);

      case FieldType.EnumerationSingle:
      case FieldType.WebhookSingle:
      case FieldType.EnumerationSingleDynamic:
      case FieldType.WebhookSingleDynamic:
        return this.renderSingleSelect(field);

      case FieldType.EnumerationMulti:
      case FieldType.WebhookMulti:
        return this.renderMultiSelect(field);

      case FieldType.Date:
        return this.renderDate(field);

      case FieldType.Time:
        return this.renderTime(field);

      default:
        return this.renderText(field);
    }
  },
  renderField: function renderField(field) {
    return _react.default.createElement(_IntegrationsActionFormField.default, {
      key: field.get('name'),
      field: field,
      invalidFields: this.getInvalidFields()
    }, this.renderFieldInner(field));
  },
  renderDate: function renderDate(field) {
    return _react.default.createElement(_CRMDateInput.default, {
      className: "form-control",
      value: this.getFieldValue(field),
      onChange: this.partial(this.handleChange, field),
      momentType: _MomentTypes.MOMENT_TYPES.PORTAL
    });
  },
  renderFormBody: function renderFormBody() {
    var _this2 = this;

    var _this$props2 = this.props,
        formData = _this$props2.actionFormInstance,
        dynamicForm = _this$props2.dynamicForm,
        submissionResponse = _this$props2.submissionResponse;
    var fields = this.getFields();

    if (formData && formData.get('error') || dynamicForm && dynamicForm.get('error') || submissionResponse && submissionResponse.get('error')) {
      return _react.default.createElement(_FormattedHTMLMessage.default, {
        message: "profileSidebarModule.integrationsActionFormError",
        key: "error"
      });
    } else if (submissionResponse && submissionResponse.get('loading')) {
      return _react.default.createElement(_FormattedHTMLMessage.default, {
        message: "profileSidebarModule.integrationsActionFormSending",
        key: "sending"
      });
    } else if (submissionResponse && submissionResponse.get('message')) {
      return _react.default.createElement("p", {
        key: "message"
      }, submissionResponse != null ? submissionResponse.get('message') : undefined);
    } else if (formData === undefined || formData.get('loading')) {
      return _react.default.createElement(_FormattedHTMLMessage.default, {
        message: "profileSidebarModule.integrationsActionFormLoading",
        key: "loading"
      });
    } else {
      var fieldComponents = [];
      fields.forEach(function (field) {
        return fieldComponents.push(_this2.renderField(field));
      });

      if (formData.get('isDynamic') && dynamicForm && dynamicForm.get('loading') === true) {
        fieldComponents.push(_react.default.createElement(_FormattedHTMLMessage.default, {
          message: "profileSidebarModule.integrationsActionFormLoading",
          key: "loading"
        }));
      }

      fieldComponents.push(this.renderAction());
      return fieldComponents;
    }
  },
  renderMultiSelect: function renderMultiSelect(field) {
    var size = field.get('options').count() > 5 ? 5 : field.get('options').count();
    var options = field.get('options').map(function (option) {
      return _react.default.createElement("option", {
        key: option.get('value'),
        value: option.get('value')
      }, option.get('label'));
    });
    return _react.default.createElement("select", {
      className: "form-control",
      multiple: "multiple",
      onChange: this.partial(this.handleChange, field),
      size: size,
      value: this.getFieldValue(field)
    }, options);
  },
  renderSingleSelect: function renderSingleSelect(field) {
    var options = field.get('options').map(function (option) {
      return {
        text: option.get('label'),
        value: option.get('value')
      };
    });

    var placeholder = field.get('placeholder') || _I18n.default.text('profileSidebarModule.integrationsActionFormSelectPlaceholder');

    return _react.default.createElement(_UISelect.default, {
      placeholder: placeholder,
      onChange: this.partial(this.handleChange, field),
      options: options.toArray(),
      value: this.getFieldValue(field)
    });
  },
  renderLongText: function renderLongText(field) {
    return _react.default.createElement(_UIExpandingTextArea.default, {
      onChange: this.partial(this.handleChange, field),
      value: this.getFieldValue(field)
    });
  },
  renderText: function renderText(field) {
    return _react.default.createElement(_UITextInput.default, {
      onChange: this.partial(this.handleChange, field),
      value: this.getFieldValue(field) || '',
      placeholder: field.get('placeholder')
    });
  },
  renderTime: function renderTime(field) {
    return _react.default.createElement(_UITimePicker.default, {
      className: "form-control",
      value: this.getFieldValue(field),
      onChange: this.partial(this.handleChange, field)
    });
  },
  render: function render() {
    return _react.default.createElement("div", {
      className: "profile-module col-xs-12 well integrations-card integrations-action-form"
    }, this.renderFormBody());
  }
});

var _default = (0, _generalStore.connect)(dependencies)(IntegrationsActionForm);

exports.default = _default;
module.exports = exports.default;